import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import TextField from "../../../Utils/TextField"
import { useFormik } from "formik"
import { getFormErrorMessage } from "../../../Utils/formikAux"
import styles from "../../../../../styles/Participant-Employment.module.css"
import { useEffect } from "react"
import EditorField from "../../../Utils/EditorField"
import CalendarField from "../../../Utils/CalendarField"
import NumberField from "../../../Utils/NumberField"

const PastJob = ({ visible, setVisible, edit, setValue, jobs, setEdit }) => {
  const { v4: uuidv4 } = require("uuid")
  const formik = useFormik({
    initialValues: {
      jobTitle: "",
      employer: "",
      jobDuties: "",
      startDate: undefined,
      endDate: undefined,
      hoursPerWeek: 0,
      findThisJob: "",
      likeJob: "",
      dislikeJob: "",
      supervisorJob: "",
      coworkersJob: "",
      leavingJob: "",
      relevantInformation: "",
    },
    validate: (data) => {
      let errors = {}
      if (data.endDate && data.startDate) {
        if (data.endDate < data.startDate) {
          errors.endDate = "Start date can not be greater than End date"
        }
      }
      return errors
    },
    onSubmit: (data) => {
      data && savePastJob(data)
      formik.resetForm()
      setVisible(false)
    },
  })
  useEffect(() => {
    if (edit) {
      formik.setValues({
        jobTitle: edit?.jobTitle,
        employer: edit?.employer,
        jobDuties: edit?.jobDuties,
        startDate: edit?.startDate ? new Date(edit?.startDate) : undefined,
        endDate: edit?.endDate ? new Date(edit?.endDate) : undefined,
        hoursPerWeek: edit?.hoursPerWeek,
        findThisJob: edit?.findThisJob,
        likeJob: edit?.likeJob,
        dislikeJob: edit?.dislikeJob,
        supervisorJob: edit?.supervisorJob,
        coworkersJob: edit?.coworkersJob,
        leavingJob: edit?.leavingJob,
        relevantInformation: edit?.relevantInformation,
        id: edit?.id,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit])
  const footer = () => {
    return (
      <div className={styles.education_form_footer}>
        <Button
          label="Cancel"
          type="button"
          onClick={() => {
            formik.resetForm()
            formik.setErrors({})
            setEdit(null)
            setVisible(false)
          }}
          className={`${styles.button} ${styles.button_secondary}`}
        />
        <Button
          label={`${edit ? "Edit" : "Create"} job`}
          type="submit"
          style={{ marginLeft: "1rem" }}
          className={`${styles.button}`}
        />
      </div>
    )
  }
  const savePastJob = (job) => {
    const cont = { ...job, id: uuidv4(), new: true }
    if (edit) {
      const newSave = jobs?.map((s) => {
        let newValue = { ...s }
        if (s.id === edit?.id) {
          newValue.jobTitle = cont.jobTitle
          newValue.employer = cont.employer
          newValue.jobDuties = cont.jobDuties
          newValue.startDate = cont.startDate
          newValue.endDate = cont.endDate
          newValue.hoursPerWeek = cont.hoursPerWeek
          newValue.findThisJob = cont.findThisJob
          newValue.likeJob = cont.likeJob
          newValue.dislikeJob = cont.dislikeJob
          newValue.supervisorJob = cont.supervisorJob
          newValue.coworkersJob = cont.coworkersJob
          newValue.leavingJob = cont.leavingJob
          newValue.relevantInformation = cont.relevantInformation
        }
        return newValue
      })
      setValue("past_jobs", newSave)
      setEdit(null)
    } else {
      const oldJobs = [...jobs]
      oldJobs.push(job)
      setValue("past_jobs", oldJobs)
    }
  }
  const header = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "solid 3px #e7e0f1",
          marginBottom: "20px",
        }}
      >
        <p
          style={{
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "33px",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >{`${edit ? "Edit" : "Add"} job`}</p>
        <Button
          className={styles.rounded_btn}
          icon="pi pi-times"
          type="button"
          onClick={() => {
            formik.resetForm()
            setVisible(false)
            setEdit(null)
          }}
          style={{ marginTop: "10px" }}
        />
      </div>
    )
  }
  return (
    <Dialog
      visible={visible}
      style={{ width: "50vw" }}
      onHide={() => {
        formik.resetForm()
        formik.setErrors({})
        setEdit(null)
        setVisible(false)
      }}
      showHeader={false}
    >
      {header()}
      <form onSubmit={formik.handleSubmit}>
        <div style={{ marginBottom: "15px" }}>
          <TextField
            label={"Job title"}
            value={formik.values.jobTitle}
            setValue={formik.setFieldValue}
            valueName={"jobTitle"}
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <TextField
            label={"Employer"}
            value={formik.values.employer}
            setValue={formik.setFieldValue}
            valueName={"employer"}
          />
        </div>
        <EditorField
          label={"Job duties"}
          onTextChange={formik.setFieldValue}
          value={formik.values.jobDuties}
          valueName={"jobDuties"}
        />
        <div style={{ display: "flex", justifyContent: "start", gap: "15px" }}>
          <CalendarField
            label={"Start date"}
            value={formik.values.startDate}
            setValue={formik.setFieldValue}
            valueName={"startDate"}
            error={getFormErrorMessage("endDate", formik)}
            size={"50"}
            maxValue={formik.values.endDate}
            showErrorMessage
          />
          <CalendarField
            label={"End date"}
            minValue={formik.values.startDate}
            value={formik.values.endDate}
            setValue={formik.setFieldValue}
            valueName={"endDate"}
            error={getFormErrorMessage("endDate", formik)}
            size={"50"}
            showErrorMessage
            subText={"(If applicable)"}
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <NumberField
            label={"How many hours per week did you work at this job?"}
            maxValue={168}
            setValue={formik.setFieldValue}
            valueName={"hoursPerWeek"}
            value={formik.values.hoursPerWeek}
            size={30}
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <TextField
            label={"How did you find this job?"}
            value={formik.values.findThisJob}
            setValue={formik.setFieldValue}
            valueName={"findThisJob"}
          />
        </div>
        <EditorField
          label={"What did you like about this job?"}
          onTextChange={formik.setFieldValue}
          value={formik.values.likeJob}
          valueName={"likeJob"}
        />
        <EditorField
          label={"What did you dislike about this job?"}
          onTextChange={formik.setFieldValue}
          value={formik.values.dislikeJob}
          valueName={"dislikeJob"}
        />
        <EditorField
          label={"What was your supervisor like at this job?"}
          onTextChange={formik.setFieldValue}
          value={formik.values.supervisorJob}
          valueName={"supervisorJob"}
        />
        <EditorField
          label={"What were your coworkers like at this job?"}
          onTextChange={formik.setFieldValue}
          value={formik.values.coworkersJob}
          valueName={"coworkersJob"}
        />
        <EditorField
          label={"Reason for leaving this job"}
          onTextChange={formik.setFieldValue}
          value={formik.values.leavingJob}
          valueName={"leavingJob"}
          placeholder={"(If applicable)"}
        />
        <EditorField
          label={"Any other relevant information about this job"}
          onTextChange={formik.setFieldValue}
          value={formik.values.relevantInformation}
          valueName={"relevantInformation"}
        />
        {footer()}
      </form>
    </Dialog>
  )
}
export default PastJob
